








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Database, Query, StoredAnswer} from '@/database';
import Table from './Table.vue';

@Component({
    components: {
        Table,
    },
})
export default class Puzzle extends Vue {
    @Prop() private id!: string;
    @Prop() private title!: string;
    @Prop() private answer_query!: string;
    @Prop() private table_names!: string[];
    @Prop() private description!: string;
    @Prop() private scroll?: boolean;
    @Prop() private challenge?: boolean;
    @Prop() private database!: () => Database | undefined;

    private answer: Query = {};
    private guess: Query = {};
    private tables: Query[] = [];
    private complete: boolean;

    data() {
        return {
            'complete': false,
            'tables': [],
        }
    }
    constructor() {
        super()
        this.complete = false;
        this.tables = [];
    }

    async created() {
        for (let table of this.table_names) {
            this.tables.push({query: `select * from ${table}`, name: table})
        }
        this.answer = {query: this.answer_query};
        this.guess = {}
        let stored = this.storedAnswer()
        if (stored) {
            this.guess = {query: stored.query}
            this.complete = stored.complete
        }
        // Wait for database to be set
        while(!this.database()) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        // todo: ugly
        for (let table of this.tables) {
            this.database()!.exec(table);
        }
        this.tables = JSON.parse(JSON.stringify(this.tables))
        this.database()!.exec(this.answer);
        this.answer = JSON.parse(JSON.stringify(this.answer))
        if (this.guess.query) {
            this.database()!.exec(this.guess);
            this.guess = JSON.parse(JSON.stringify(this.guess))
        }
    }

    storedAnswer(): StoredAnswer | undefined{
        let str = localStorage.getItem(this.id)
        if (!str) {
            return undefined
        }
        return JSON.parse(str)
    }

    values(query: Query): any {
        if (query.result === undefined || query.result[0] === undefined) {
            return ""
        }
        return query.result[0].values
    }

    async runQuery(event: any) {
        // todo: ugly
        while(!this.database()) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        this.database()!.exec(this.guess);
        this.guess = JSON.parse(JSON.stringify(this.guess))
        console.log("the guess is", this.guess.result)
        let completed = JSON.stringify(this.values(this.guess)) == JSON.stringify(this.values(this.answer));
        console.log('guess', JSON.stringify(this.values(this.guess)))
        console.log('answer', JSON.stringify(this.values(this.answer)))
        this.complete = completed
        this.save();

        // @ts-ignore
        while(!this.$firedb) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        // @ts-ignore
        this.$firedb.collection("sql-attempts").add({
            query: this.guess.query,
            // @ts-ignore
            uuid: this.$uuid,
            correct: completed,
            puzzle_id: this.id,
            version: "joins-challenge-1-wf-update",
            timestamp: Math.floor(Date.now() / 1000),
        })
    }

    save() {
        let stored = {
            query: this.guess.query,
            complete: this.complete,
        }
        localStorage.setItem(this.id, JSON.stringify(stored))
    }
}
